import React, { useEffect, createElement } from 'react';
interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonicalUrl?: string;
}
export function SEOHead({
  title = 'Anifit Hondenvoer | 10% Korting + Gratis Voedingsadvies | Stressless Dogs',
  description = 'Ontdek waarom baasjes overstappen naar Anifit hondenvoer. 90-99% vleesgehalte, Zweeds kwaliteitsvlees, geen conserveringsmiddelen. Bestel met 10% korting (code: stressless) + gratis persoonlijk voedingsadvies van Stressless Dogs.',
  keywords = 'anifit, hondenvoer, natvoer hond, premium hondenvoer, gezond hondenvoer, stressless dogs, hondenvoeding, zweeds hondenvoer, natuurlijk hondenvoer, honden voedingsadvies',
  ogImage = 'https://cdn.magicpatterns.com/uploads/x3GExsknAqXKERwsFg6zKP/freepik__row-of-dog-food-cans-on-a-clean-dining-table-in-a-__10482_(1).png',
  canonicalUrl = 'https://stresslessdogs.nl/anifit'
}: SEOHeadProps) {
  useEffect(() => {
    // Set document title
    document.title = title;
    // Helper function to set or update meta tags
    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // Basic meta tags
    setMetaTag('description', description);
    setMetaTag('keywords', keywords);
    setMetaTag('author', 'Stressless Dogs');
    setMetaTag('robots', 'index, follow');
    setMetaTag('language', 'Dutch');
    setMetaTag('revisit-after', '7 days');
    // Open Graph meta tags (Facebook, LinkedIn)
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', canonicalUrl, true);
    setMetaTag('og:image', ogImage, true);
    setMetaTag('og:site_name', 'Stressless Dogs', true);
    setMetaTag('og:locale', 'nl_NL', true);
    // Twitter Card meta tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', ogImage);
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
    // Viewport (if not already set)
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1.0';
      document.head.appendChild(viewport);
    }
    // Charset (if not already set)
    if (!document.querySelector('meta[charset]')) {
      const charset = document.createElement('meta');
      charset.setAttribute('charset', 'UTF-8');
      document.head.insertBefore(charset, document.head.firstChild);
    }
  }, [title, description, keywords, ogImage, canonicalUrl]);
  return null;
}